module.exports = __webpack_public_path__ + "img/question.6473a797.svg";